module.exports = __webpack_public_path__ + "static/media/Agri-Business_Challenges_13-02-2024-removebg-preview.6b1fba01.png";